export enum RewardSettingsType {
  'Credit Bonus' = 1,
  'Physical Gift'
}
